import { render, staticRenderFns } from "./tm-menu-item.vue?vue&type=template&id=9e4e971e&scoped=true&"
import script from "./tm-menu-item.vue?vue&type=script&lang=ts&"
export * from "./tm-menu-item.vue?vue&type=script&lang=ts&"
import style0 from "./tm-menu-item.vue?vue&type=style&index=0&id=9e4e971e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e4e971e",
  null
  
)

export default component.exports